import React, { useState } from "react";
import Box from "@mui/material/Box";
import { Fab, Fade } from "@mui/material";
import Typography from "@mui/material/Typography";
import { makeStyles } from "tss-react/mui";
import Divider from "@mui/material/Divider";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import ReceivedInvitationList from "./received-invitation-list";
import { DEFAULT_FADE_ANIMATION } from "../../constants";
import TitleBar from "../nav/title-bar";
import AddFriendDialog from "./add-friend-dialog";
import FriendList from "./friend-list";
import SentInvitationList from "./sent-invitation-list";

const useStyles = makeStyles()((theme) => ({
  heading: {
    margin: "10px auto",
    fontWeight: 300,
    textAlign: "center",
  },

  divider: {
    marginTop: "5px",
    marginBottom: "5px",
  },

  fab: {
    position: "fixed",
    bottom: theme.spacing(12),
    right: theme.spacing(4),
    zIndex: 2,
  },
}));

export default function Friends() {
  const { classes } = useStyles();
  const [addFriendDialogOpen, setAddFriendDialogOpen] = useState(false);

  function addFriend() {
    setAddFriendDialogOpen(true);
  }

  return (
    <Box>
      <TitleBar title="Friends" />
      <Fade in timeout={DEFAULT_FADE_ANIMATION}>
        <Box>
          <Typography variant="h5" className={classes.heading}>
            Invitations
          </Typography>
          <ReceivedInvitationList />
          <Divider className={classes.divider} variant="middle" />
          <Typography variant="h5" className={classes.heading}>
            Pending Friend Requests
          </Typography>
          <SentInvitationList />
          <Divider className={classes.divider} variant="middle" />
          <Typography variant="h5" className={classes.heading}>
            Friends
          </Typography>
          <FriendList />
          <Divider className={classes.divider} variant="middle" />
          <Fab
            onClick={addFriend}
            color="primary"
            aria-label="add"
            className={classes.fab}
          >
            <PersonAddIcon />
          </Fab>
          <AddFriendDialog
            open={addFriendDialogOpen}
            handleClose={() => setAddFriendDialogOpen(false)}
          />
        </Box>
      </Fade>
    </Box>
  );
}
